import { AlertTriangle } from "lucide-react";
import { Reveal } from "./Reveal";

export default function RiskNote({ title = "Risk disclosure", lines = [], testid = "risk-note" }) {
  return (
    <Reveal>
      <div
        data-testid={testid}
        className="rounded-2xl border border-crimson-400/25 bg-crimson-400/[0.05] p-6 sm:p-8"
      >
        <div className="flex items-center gap-3 mb-4">
          <AlertTriangle size={16} className="text-crimson-400" />
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-crimson-400">
            {title}
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {lines.map((l, i) => (
            <p key={i} className="text-sm text-zinc-400 leading-relaxed">
              {l}
            </p>
          ))}
        </div>
      </div>
    </Reveal>
  );
}